;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface MaestroCardDarkIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function MaestroCardDarkIcon({ size = 24, ...props }: MaestroCardDarkIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_14457_55)">
        <rect y="0.599976" width="42" height="29.4" rx="4" fill="white" />
        <path
          d="M2.62496 0.599976H39.375C40.8241 0.599976 42 1.7452 42 3.15762V27.4436C42 28.8548 40.8241 30 39.375 30H2.62496C1.17465 30.0001 0 28.8548 0 27.4437V3.15762C0 1.7452 1.17594 0.599976 2.62496 0.599976Z"
          fill="#222222"
        />
        <path d="M24.8163 8.69714H17.6411V21.9038H24.8163V8.69714Z" fill="#6C6BBD" />
        <path
          d="M18.095 15.3C18.095 12.6167 19.3251 10.2367 21.2157 8.69669C19.8262 7.57669 18.0722 6.90002 16.1589 6.90002C11.6259 6.90002 7.9586 10.6567 7.9586 15.3C7.9586 19.9434 11.6259 23.7 16.1589 23.7C18.0722 23.7 19.8262 23.0234 21.2157 21.9034C19.3251 20.3867 18.095 17.9834 18.095 15.3Z"
          fill="#EB001B"
        />
        <path
          d="M34.4962 15.3C34.4962 19.9434 30.8288 23.7 26.2959 23.7C24.3825 23.7 22.6286 23.0234 21.2391 21.9034C23.1525 20.3634 24.3597 17.9834 24.3597 15.3C24.3597 12.6167 23.1297 10.2367 21.2391 8.69669C22.6286 7.57669 24.3825 6.90002 26.2959 6.90002C30.8288 6.90002 34.4962 10.68 34.4962 15.3Z"
          fill="#0099DF"
        />
      </g>
      <defs>
        <clipPath id="clip0_14457_55">
          <rect y="0.599976" width="42" height="29.4" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
